let nextId = 0;

/**
 * Returns a unique `titleId` / `descId` pair for one dialog instance. Shared by the
 * declarative `compsych-dialog` and the imperative `DialogService` so ids never collide
 * when both kinds of dialog are open at once (e.g. GRO's `ModalService` delegating here).
 */
export function nextDialogIds(): { titleId: string; descId: string } {
  const id = nextId++;
  return { titleId: `cmp-dialog-title-${id}`, descId: `cmp-dialog-desc-${id}` };
}
